import axios from "axios";
import React, { Component } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { apiCall_domain } from "../api";
import BreadCrumb from "../global/BreadCrumb";
import PulseLoader from "react-spinners/PulseLoader";

class ProductsInfo extends Component {
  state = {
    isNotified: false,
    loading: false,
  };
  componentDidMount() {
    this.setState({ isNotified: this.props.product.is_notified });
  }
  notifyMe = () => {
    const config = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    const data = {
      item_id: this.props.product.id,
    };
    this.setState({ loading: true }, () => {
      axios
        .post(`${apiCall_domain}/customer/user/notify-me`, data, {
          headers: config,
        })
        .then((res) => {
          this.setState({ isNotified: true, loading: false });
        });
    });
  };

  dontNotifyMe = () => {
    const config = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    const data = {
      id: this.props.product.id,
    };
    this.setState({ loading: true }, () => {
      axios
        .post(`${apiCall_domain}/customer/user/notify-me/delete`, data, {
          headers: config,
        })
        .then((res) => {
          this.setState({ isNotified: false, loading: false });
        });
    });
  };
  render() {
    const { id, name, category_id, category, stock, min_price, pics } =
      this.props.product || {};
    return (
      <div className="productInfo">
        <div className="container">
          <div className="picsSlider">
            <Swiper spaceBetween={21} slidesPerView={1}>
              {pics.map((item) => (
                <SwiperSlide>
                  <div className="images">
                    <img
                      src={`${item}`}
                      alt="عکس"
                      onClick={this.props.handleImageGallery}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="info">
            <BreadCrumb
              routes={[
                { link: "/homePage", name: "فروشگاه اینترنتی کاچار" },
                { link: `/categories/${category_id}`, name: category },
                { link: `/product/${id}`, name },
              ]}
            />
            <h3>{name} </h3>
            {stock > 1 ? (
              <div className="price">
                شروع قیمت از : <span>{min_price.toLocaleString()} </span> تومان
              </div>
            ) : (
              <div className="outOfStock">
                <div className="stockNoItem price">ناموجود</div>
                {stock === 0 && this.state.isNotified ? (
                  <button className="dontNotify" onClick={this.dontNotifyMe}>
                    {this.state.loading ? (
                      <PulseLoader size={10} color="#831f82" loading={true} />
                    ) : (
                      " دیگه لازم نیست اطلاع بدی !"
                    )}
                  </button>
                ) : (
                  <button className="notify" onClick={this.notifyMe}>
                    {this.state.loading ? (
                      <PulseLoader size={10} color="#fff" loading={true} />
                    ) : (
                      "موجود شد به من اطلاع بده !"
                    )}
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default ProductsInfo;
